import * as GlobeActions from '~app/actions/globe';
import * as VectorActions from '~app/actions/vector';
import makeReducer from '~app/core/makeReducer';

const initialState = {
  gridVisible: false,
  bordersVisible: false,
  gridVectors: [],
  borderVectors: [],
  vectors: [],
  globeGridLabels: [],
  globeBorderLabels: [],
  mapGridLabels: [],
  mapBorderLabels: [],
  labels: [],
  morphMode: '3D',
};

function loadedGridVector(state, {geoJsonDataSource, globeLabels, mapLabels}) {
  return {
    ...state,
    gridVectors: [...state.gridVectors, geoJsonDataSource],
    globeGridLabels: [...state.globeGridLabels, ...globeLabels],
    mapGridLabels: [...state.mapGridLabels, ...mapLabels],
  };
}

function loadedBorderVector(state, {geoJsonDataSource, globeLabels, mapLabels}) {
  return {
    ...state,
    borderVectors: [...state.borderVectors, geoJsonDataSource],
    globeBorderLabels: [...state.globeBorderLabels, ...globeLabels],
    mapBorderLabels: [...state.mapBorderLabels, ...mapLabels],
  };
}

function showGrid(state, {visible}) {
  return {
    ...state,
    gridVisible: visible,
    vectors: getActiveVectors(state, visible, state.bordersVisible),
    labels: getActiveLabels(state, visible, state.bordersVisible, state.morphMode),
  };
}

function showBorders(state, {visible}) {
  return {
    ...state,
    bordersVisible: visible,
    vectors: getActiveVectors(state, state.gridVisible, visible),
    labels: getActiveLabels(state, state.gridVisible, visible, state.morphMode),
  };
}

function getActiveVectors(state, gridVisible, bordersVisible) {
  let vectors = [];
  if (gridVisible) {
    vectors = [...vectors, ...state.gridVectors];
  }
  if (bordersVisible) {
    vectors = [...vectors, ...state.borderVectors];
  }
  return vectors;
}

function getActiveLabels(state, gridVisible, bordersVisible, morphMode) {
  let labels = [];
  if (gridVisible) {
    if (morphMode === '2D') {
      labels = [...labels, ...state.mapGridLabels];
    }
    else if (morphMode === '3D') {
      labels = [...labels, ...state.globeGridLabels];
    }
  }
  if (bordersVisible) {
    if (morphMode === '2D') {
      labels = [...labels, ...state.mapBorderLabels];
    }
    else if (morphMode === '3D') {
      labels = [...labels, ...state.globeBorderLabels];
    }
  }
  return labels;
}

function morphGlobeRequested(state, {mode}) {
  return {
    ...state,
    morphMode: 'Morphing',
    labels: getActiveLabels(state, state.gridVisible, state.borderVectors, 'Morphing'),
  };
}

function morphGlobeFinished(state, {mode}) {
  return {
    ...state,
    morphMode: mode,
    labels: getActiveLabels(state, state.gridVisible, state.borderVectors, mode),
  };
}

const ACTION_HANDLERS = {
  [VectorActions.LOADED_GRID_VECTOR]: loadedGridVector,
  [VectorActions.LOADED_BORDER_VECTOR]: loadedBorderVector,

  [VectorActions.SHOW_GRID]: showGrid,
  [VectorActions.SHOW_BORDERS]: showBorders,

  [GlobeActions.MORPH_GLOBE_REQUEST]: morphGlobeRequested,
  [GlobeActions.MORPH_GLOBE_FINISHED]: morphGlobeFinished,
};

export default makeReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/store/vectorReducer.js